import { IonContent, IonHeader, IonPage, useIonRouter } from '@ionic/react'
import { useQueryClient } from '@tanstack/react-query'

import { CheckInLoyaltyHeader } from '../../../../check-in/components/check-in-loyalty-header'
import { PairedLoyaltyDetail } from '../../../../check-in/paired/components/paired-loyalty-detail'
import { useUpdateClientStation } from '../../../../check-in/paired/mutations'
import { checkInQueryKeys } from '../../../../check-in/paired/queries'
import { useStationClientId } from '../../../../check-in/paired/utils'

function LoyaltyDetailPage() {
  const queryClient = useQueryClient()
  const stationClientId = useStationClientId()

  const { mutate: updateStation } = useUpdateClientStation()
  const router = useIonRouter()

  function handleFinish() {
    if (stationClientId)
      return updateStation(
        { objectId: stationClientId, status: 'completed' },
        { onSuccess: () => redirect() }
      )

    redirect()
  }
  function redirect() {
    queryClient.invalidateQueries({
      queryKey: checkInQueryKeys.clientStations(),
      exact: false,
    })

    router.push('/check-in/paired/admin/home', 'back', 'pop')
  }

  return (
    <IonPage>
      <IonHeader>
        <CheckInLoyaltyHeader onFinish={handleFinish} />
      </IonHeader>
      <IonContent className="ion-padding">
        <PairedLoyaltyDetail />
      </IonContent>
    </IonPage>
  )
}

export { LoyaltyDetailPage }
